module.exports = __webpack_public_path__ + "static/img/calendar-house.dbcb6167.svg";